
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/wm-workflow-management",
      function () {
        return require("private-next-pages/solutions/wm-workflow-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/wm-workflow-management"])
      });
    }
  